var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3129 12.2422L14.4169 13.1382L16.3369 15.0582H8.88086V16.6582H16.3369L14.4169 18.5782L15.3129 19.4742L18.9289 15.8582L15.3129 12.2422Z",
    fill: "#25487D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9613 15.0625H4.5293V16.6625H6.9613V15.0625Z",
    fill: "#25487D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9935 7.69922H16.5615V9.29922H18.9935V7.69922Z",
    fill: "#25487D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18477 9.29881H14.6408V7.69881H7.18477L9.10477 5.77881L8.20877 4.88281L4.59277 8.49881L8.20877 12.1148L9.10477 11.2188L7.18477 9.29881Z",
    fill: "#25487D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.fdd3b3bbfa981bb393e1ec314dee544f.svg";
export { ForwardRef as ReactComponent };